import React from "react";

const LINE_BREAK_PATTERN = /\r?\n|\\n/;
const INLINE_TOKEN_PATTERN = /\[([^\]]+)\]\(([^)]+)\)|\*\*([^*]+)\*\*/g;
const ALLOWED_SCHEMES = ["http:", "https:", "mailto:"];

const isAllowedUrl = (url: string): boolean => {
  try {
    const scheme = new URL(url).protocol;
    return ALLOWED_SCHEMES.includes(scheme);
  } catch {
    return false;
  }
};

const parseInlineTokens = (line: string, linkClassName: string | undefined, keyPrefix: string): React.ReactNode[] => {
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  let match: RegExpExecArray | null;

  INLINE_TOKEN_PATTERN.lastIndex = 0;
  while ((match = INLINE_TOKEN_PATTERN.exec(line)) !== null) {
    const [fullMatch, linkLabel, url, boldLabel] = match;

    if (match.index > lastIndex) {
      nodes.push(line.slice(lastIndex, match.index));
    }

    if (linkLabel !== undefined) {
      if (isAllowedUrl(url)) {
        nodes.push(
          <a
            key={`${keyPrefix}-${key++}`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            {linkLabel}
          </a>,
        );
      } else {
        nodes.push(fullMatch);
      }
    } else {
      nodes.push(<strong key={`${keyPrefix}-${key++}`}>{boldLabel}</strong>);
    }

    lastIndex = match.index + fullMatch.length;
  }

  if (lastIndex < line.length) {
    nodes.push(line.slice(lastIndex));
  }

  return nodes;
};

export const parseInfoText = (text: string, linkClassName?: string): React.ReactNode[] => {
  if (!text) return [];

  const nodes: React.ReactNode[] = [];
  const lines = text.split(LINE_BREAK_PATTERN);

  lines.forEach((line, index) => {
    if (index > 0) {
      nodes.push(<br key={`br-${index}`} />);
    }
    nodes.push(...parseInlineTokens(line, linkClassName, `line-${index}`));
  });

  return nodes;
};
